import { render } from "./Tasklist.vue?vue&type=template&id=b80b0c58&scoped=true"
import script from "./Tasklist.vue?vue&type=script&lang=js"
export * from "./Tasklist.vue?vue&type=script&lang=js"

import "./Tasklist.vue?vue&type=style&index=0&id=b80b0c58&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b80b0c58"]])

export default __exports__